// ===========================================================================
// Clinical Notes Transcriptor — constantes del módulo.
//
// Módulo MOBILE-FIRST: es el único que se muestra en el sidebar cuando la app
// se abre desde un celular (ver `mobile: true` en config/navigationConfig.js y
// el filtro en NavigationSections). En desktop convive con el resto.
//
// Paso 1 (este archivo): agenda del día — todos los appointments de AdvancedMD,
// filtrables por location y provider, igual que Pre-Visit Planning y CDCI.
// ===========================================================================

export const TRANSCRIPTOR_BASE_PATH = "/clinical-notes-transcriptor";

export const TRANSCRIPTOR_MODULE_TAG = "Transcriptor";

/** Valor "todas" para los selects de location / provider. */
export const ALL = "";

/**
 * Estado de la cita para la pastilla de la card / grilla. Se deriva de
 * `amdStatus` (>= 10 = cancelada/borrada) e `isConfirmed`, igual que CDCI.
 */
export const APPT_STATUS_META = {
  CANCELLED: { tone: "muted", label: "Cancelled" },
  CONFIRMED: { tone: "ok", label: "Confirmed" },
  SCHEDULED: { tone: "info", label: "Scheduled" },
};

export const getApptStatusKey = (a) => {
  if (a?.isCancelledOrDeleted) return "CANCELLED";
  return a?.isConfirmed ? "CONFIRMED" : "SCHEDULED";
};
